export const px = (value: number) => `${value}px`;
